export const config = {
  // host_api: "http://localhost:3000/api/v1/",
  // host_api: "https://c2f.chula.ac.th/member/api/v1/",
  host_api: "https://c2f-member-api.ideabranch.co.th/api/v1/",
  ROLE_ADMIN: "admin",
  ROLE_MENTOR: "mentor",
  ROLE_PHD_3Y: "phd_3y",
  ROLE_PHD_5Y: "phd_5y",
  ROLE_POSTDOC: "post_doc"
  };
